import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homeone-testimonials',
    templateUrl: './homeone-testimonials.component.html',
    styleUrls: ['./homeone-testimonials.component.scss']
})
export class HomeoneTestimonialsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Client Testimonials",
            title: ' Are Saying?',
            paragraphText: 'Serving clients around the world, we provide cost-effective solutions in diverse industries – from energy to manufacturing to utilities. Each client is provided a customized connectivity package that builds operational intelligence to make superior data-driven decisions – all presented and delivered in an easy to use dashboard (MES)'
        }
    ]

    testimonialsBtn: Btn[] = [
        {
            link: "/Client-Testimonials",
            icon: 'flaticon-view',
            text: 'Check Out All Reviews'
        }
    ]
    showDiv = {
        previous : false,
        current : false,
        next : true,
        nextTo:false,
      }

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}

class Btn {
    link : string;
    icon : string;
    text : string;
}